import { Divider, Grid } from '@material-ui/core'
import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import Logo from '../../../assets/img/butterfly-logo.png'
import MyCareLogo from '../../../assets/img/icons/mycare.png'
import AddOnServices from '../../CreateAQuote/EstimatedCosts/AddOnServices'
import DeliveryDetails from '../../CreateAQuote/EstimatedCosts/DeliveryDetails'
import Request from '../../CreateAQuote/EstimatedCosts/Request'
import TotalCost from '../../CreateAQuote/EstimatedCosts/TotalCost'
import ProjectCharges from './ProjectCharges'

const RequestSummary = ({ innerRef, setReady }) => {
  const { project } = useSelector((state) => state.projectDetails)

  useEffect(() => {
    setTimeout(() => {
      setReady(true)
    }, 3500)

    return () => {
      setReady(false)
    }
  }, [setReady])

  return (
    <div ref={innerRef} className="request-summary estimated-cost m-t-20">
      <img src={Logo} alt="Hexagon Logo" style={{ width: 232 }} />

      <div className="gradient-bg m-b-40 m-t-40" style={{ height: 8 }}></div>
      <h2 className="m-b-40">Project summary</h2>

      <h4 className="m-b-16">Customer information</h4>

      <Grid container spacing={4}>
        <Grid item sm={6} xs={12} className="customer-info">
          <div className="flex m-b-0">
            <div className="label m-r-5 strong">Name: </div>
            <div>{project.userName}</div>
          </div>

          {project.company && (
            <>
              <div className="flex m-b-0">
                <div className="label m-r-5 strong">Company: </div>
                <div>
                  {project.company.companyName
                    ? project.company.companyName
                    : 'Unknown'}
                </div>
              </div>
              <div className="flex m-b-0">
                <div className="label m-r-5 strong">Location: </div>
                <div>
                  {project.company.city && project.company.state
                    ? `${project.company.city}, ${project.company.state}`
                    : 'Unknown'}
                </div>
              </div>
            </>
          )}

          <div className="flex m-b-0">
            <div className="label m-r-5 strong">Email: </div>
            <div>{project.userEmail}</div>
          </div>

          <div className="flex m-b-0">
            <div className="label m-r-5 strong">Phone: </div>
            <div>
              {project.userPhone ? project.userPhone : <em>None added</em>}
            </div>
          </div>
        </Grid>

        <Grid item sm={4} xs={12}>
          {project.isMyCareMember && (
            <p className="m-b-16">
              <img
                src={MyCareLogo}
                alt="MyCare Logo"
                style={{ width: 32, marginRight: 16 }}
              />
              <strong>MyCare member</strong>
            </p>
          )}
        </Grid>
      </Grid>

      <h4 className="m-b-16 m-t-20">Project name</h4>

      <p className="m-b-40">{project.name}</p>

      {project.description && (
        <>
          <h4 className="m-b-16">Description</h4>
          <p className="m-b-40">{project.description}</p>
        </>
      )}

      <Divider className="m-b-40" />

      <Grid item xs={6} className="total-cost">
        {project.charges && project.charges.length ? (
          <ProjectCharges />
        ) : (
          <TotalCost interactive={false} />
        )}
      </Grid>

      <Divider className="m-t-40" />
      <h2 className="m-b-12 m-t-40">Project details</h2>

      {project.requests &&
        project.requests.map((request, index) => (
          <Request
            request={request}
            key={index}
            index={index}
            isRequestSummary={true}
          />
        ))}

      <DeliveryDetails isRequestSummary={true} />

      <AddOnServices isRequestSummary={true} />
    </div>
  )
}

export default RequestSummary
